export default __webpack_public_path__ + "static/bg-3-9a79fbdbbf8282e2a7f95c4d55e59719.png";